import { createSelector } from 'reselect';

export const productDetailsAttributeSelector = createSelector(
  state => state.product,
  product => product.details.attributes,


);

export const minimumOrderQuantitySelector = createSelector(
  state => state.product,
  product => product.details.attributes.minimumOrderQuantity,
);
